import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import img13 from "../assets/images/img13.avif";
import img18 from "../assets/images/img18.jpg";
import img19 from "../assets/images/img19.jpg";
import img20 from "../assets/images/img20.jpg";
import smartImg from "../assets/images/smart.jpeg";
import villaImg from "../assets/images/villa.jpeg";

const SERVICES = [
  {
    icon: "🏗",
    tabler: "ti-building",
    title: "Building Contracting",
    short: "Complete building construction and contracting solutions.",
    description: "We provide end-to-end building contracting services for residential, commercial, and industrial projects across the UAE. Our expert team manages everything from initial planning to final handover, ensuring structural integrity, quality materials, and timely delivery.",
    color: "#1a6ab5",
    bg: "#e8f4fd",
  },
  {
    tabler: "ti-tools",
    title: "Metal Parts & Erection",
    short: "Precision metal fabrication and structural erection.",
    description: "Our metal works division specialises in fabrication, welding, and erection of structural steel components. We handle everything from custom metal parts manufacturing to complete structural steel erection, ensuring strength and compliance with UAE safety standards.",
    color: "#0d3c6e",
    bg: "#cce7f8",
  },
  {
    tabler: "ti-solar-panel",
    title: "Solar Energy Installation",
    short: "Professional solar panel installation across UAE.",
    description: "We design and install high-efficiency solar energy systems for residential, commercial, and industrial properties. Our certified technicians handle complete system design, panel mounting, inverter installation, and grid connection.",
    color: "#e8a800",
    bg: "#fff8e1",
  },
  {
    tabler: "ti-bolt",
    title: "Electrical Works",
    short: "Expert electrical installation, repair, and maintenance.",
    description: "Our licensed electricians provide comprehensive electrical services including wiring installations, circuit breaker replacements, lighting fixture installations, and electrical fault diagnosis — compliant with UAE electrical codes.",
    color: "#1a6ab5",
    bg: "#e8f4fd",
  },
  {
    tabler: "ti-plant",
    title: "Landscape & Resort",
    short: "Beautiful landscape design and resort development.",
    description: "Transform outdoor spaces with our professional landscaping services. We design and construct lush gardens, walkways, outdoor lighting, irrigation systems, and complete resort amenity areas that enhance property value.",
    color: "#2e7d32",
    bg: "#e8f5e9",
  },
  {
    tabler: "ti-layout-grid",
    title: "Floor & Wall Tiling",
    short: "Precision tiling for floors and walls of all types.",
    description: "Our skilled tiling team delivers flawless floor and wall tiling across all spaces — from luxury residential bathrooms to large commercial floors. We work with ceramic, porcelain, marble, and mosaic materials.",
    color: "#0d3c6e",
    bg: "#cce7f8",
  },
  {
    tabler: "ti-paint",
    title: "Painting Contracting",
    short: "Professional interior and exterior painting.",
    description: "We offer premium painting services for both interior and exterior surfaces. Our team uses high-quality, weather-resistant paints suited to the UAE climate, including decorative finishes and anti-fungal coatings.",
    color: "#c62828",
    bg: "#ffebee",
  },
  {
    tabler: "ti-armchair",
    title: "Carpentry & Flooring",
    short: "Custom carpentry and premium flooring installation.",
    description: "Our carpentry division offers custom woodwork including built-in wardrobes, kitchen cabinets, doors, and decorative panels. Flooring services include hardwood, laminate, vinyl, and parquet installation.",
    color: "#6d4c41",
    bg: "#efebe9",
  },
  {
    tabler: "ti-layers-intersect",
    title: "Insulation Contracting",
    short: "Thermal and acoustic insulation for all buildings.",
    description: "We provide thermal, acoustic, and waterproof insulation for roofs, walls, floors, and pipework. Our systems reduce energy consumption, improve comfort, and protect structures from heat and moisture damage.",
    color: "#1a6ab5",
    bg: "#e8f4fd",
  },
  {
    tabler: "ti-pencil",
    title: "Engraving & Ornamentation",
    short: "Decorative engraving and ornamental finishing.",
    description: "We specialise in architectural engraving, ornamental plasterwork, decorative stone carving, and custom ornamentation for buildings. Our craftsmen bring artistic detail to facades, lobbies, and interior spaces.",
    color: "#6a1b9a",
    bg: "#f3e5f5",
  },
  {
    tabler: "ti-fence",
    title: "All Types Fencing",
    short: "Security and decorative fencing for all properties.",
    description: "We install all types of fencing solutions including steel, aluminium, wooden, chain-link, and decorative boundary fences for residential, commercial, and industrial perimeters.",
    color: "#0d3c6e",
    bg: "#cce7f8",
  },
  {
    tabler: "ti-layout-rows",
    title: "False Ceiling & Partitions",
    short: "Modern false ceilings and partition wall systems.",
    description: "We design and install suspended false ceilings in gypsum, metal grid, PVC, and stretch systems. Our light partition solutions allow flexible space division integrating seamlessly with lighting and HVAC systems.",
    color: "#1a6ab5",
    bg: "#e8f4fd",
  },
  {
    tabler: "ti-square-rounded-plus",
    title: "Plaster Works",
    short: "Professional interior and exterior plastering.",
    description: "Our plasterers deliver high-quality interior and exterior plaster finishes for new builds and renovations. Services include smooth sand-cement rendering, gypsum plastering, decorative textured finishes, and patch repairs.",
    color: "#e8a800",
    bg: "#fff8e1",
  },
  {
    tabler: "ti-droplet",
    title: "Sanitary Installation",
    short: "Complete sanitary fitting and pipe repair services.",
    description: "We handle full sanitary installations including toilets, basins, showers, bathtubs, and all associated pipework. Rapid pipe repair services for leaks, bursts, and blockages — residential and commercial.",
    color: "#0288d1",
    bg: "#e1f5fe",
  },
  {
    tabler: "ti-pipe",
    title: "Plumbing Contracting",
    short: "Full-scope plumbing contracting for any project.",
    description: "Our licensed plumbing contractors undertake complete plumbing systems for new builds and major renovations — water supply lines, drainage networks, hot water systems, and sanitary installations.",
    color: "#0d3c6e",
    bg: "#cce7f8",
  },
  {
    tabler: "ti-cpu",
    title: "Electromechanical Works",
    short: "Expert electromechanical systems installation and maintenance.",
    description: "We install, commission, and maintain HVAC units, pumps, generators, elevators, fire suppression systems, and building automation controls — trained for both low-voltage and high-voltage systems.",
    color: "#1a6ab5",
    bg: "#e8f4fd",
  },
];

const POOL_IMAGES = [img18, img19, img20];

export default function Services() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [activePool, setActivePool] = useState(0);
  const [hoveredIdx, setHoveredIdx] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setActivePool(p => (p + 1) % POOL_IMAGES.length), 3200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ fontFamily:"'Barlow',sans-serif", background:"#f0f7ff", minHeight:"100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600;700&display=swap" rel="stylesheet"/>
      <style>{`
        @keyframes fadeLeft { from{opacity:0;transform:translateX(-40px)} to{opacity:1;transform:translateX(0)} }
        @keyframes fadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
        @keyframes expandDesc { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
        @keyframes numberCount { from{opacity:0;transform:scale(0.8)} to{opacity:1;transform:scale(1)} }
        .svc-row { border-bottom: 1px solid rgba(26,106,181,0.1); transition: background 0.22s; cursor:pointer; }
        .svc-row:last-child { border-bottom: none; }
        .svc-row:hover { background: rgba(26,106,181,0.04) !important; }
        .svc-number { font-family:'Barlow Condensed',sans-serif; font-weight:900; font-size:13px; color:rgba(26,106,181,0.3); min-width:32px; }
        @media(max-width:768px){ .pool-grid{grid-template-columns:1fr !important;} .hero-services-grid{grid-template-columns:1fr !important;} }
      `}</style>

      <Navbar />

      {/* HERO */}
      <section style={{ position:"relative", height:340, overflow:"hidden", display:"flex", alignItems:"center", paddingTop:72 }}>
        <img src={img13} alt="Services" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center" }}/>
        <div style={{ position:"absolute", inset:0, background:"linear-gradient(135deg,rgba(13,60,110,0.82) 0%,rgba(26,106,181,0.65) 100%)" }}/>
        <div style={{ position:"relative", zIndex:2, maxWidth:1200, margin:"0 auto", padding:"0 24px", opacity:visible?1:0, animation:visible?"fadeLeft 0.8s ease forwards":"none" }}>
          <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(40px,6vw,72px)", fontWeight:900, color:"#fff", margin:"0 0 14px", textTransform:"uppercase", letterSpacing:-1 }}>Our Services</h1>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <a href="/" style={{ color:"rgba(255,255,255,0.65)", fontSize:14, textDecoration:"none" }}>Home</a>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            <span style={{ color:"#e8a800", fontSize:14, fontWeight:600 }}>Our Services</span>
          </div>
        </div>
      </section>


      {/* ── FEATURED: SMART FENCING ── */}
      <section style={{ background:"#fff", padding:"48px 24px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:64, alignItems:"center" }}>
            <div style={{ position:"relative", borderRadius:20, overflow:"hidden", boxShadow:"0 20px 60px rgba(13,60,110,0.18)" }}>
              <img src={smartImg} alt="Smart Fencing" style={{ width:"100%", display:"block", objectFit:"cover", transition:"transform 0.5s" }}
                onMouseEnter={e => e.currentTarget.style.transform="scale(1.03)"}
                onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}
              />
              <div style={{ position:"absolute", top:20, left:20, background:"#0d3c6e", borderRadius:10, padding:"8px 16px" }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, fontWeight:800, color:"#e8a800", textTransform:"uppercase", letterSpacing:1 }}>Featured Service</div>
              </div>
            </div>
            <div>
              <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:12 }}>Security Solutions</div>
              <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(28px,4vw,46px)", fontWeight:900, color:"#0d3c6e", margin:"0 0 6px", textTransform:"uppercase", lineHeight:1.1 }}>Smart Fencing</h2>
              <p style={{ color:"#e8a800", fontWeight:700, fontSize:16, margin:"0 0 18px" }}>Stronger. Safer. Smarter.</p>
              <p style={{ color:"#3a6080", fontSize:15, lineHeight:1.85, margin:"0 0 24px" }}>We install all types of fencing solutions including steel, aluminium, chain-link, corrugated, and solid hoarding fences for residential, commercial, and industrial perimeters across UAE.</p>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:28 }}>
                {[
                  { icon:<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>, label:"Durable", sub:"Built to Last" },
                  { icon:<><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>, label:"Secure", sub:"Enhanced Safety" },
                  { icon:<><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></>, label:"Low Maintenance", sub:"Long-Term Savings" },
                  { icon:<><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>, label:"Versatile", sub:"Suitable for All Needs" },
                ].map(({ icon, label, sub }) => (
                  <div key={label} style={{ display:"flex", gap:12, alignItems:"flex-start", background:"#f0f7ff", borderRadius:10, padding:"12px 14px" }}>
                    <div style={{ width:36, height:36, background:"#1a6ab5", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icon}</svg>
                    </div>
                    <div>
                      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:14, color:"#0d3c6e", textTransform:"uppercase" }}>{label}</div>
                      <div style={{ color:"#5a80a0", fontSize:12 }}>{sub}</div>
                    </div>
                  </div>
                ))}
              </div>
              <a href="/contact#form" style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#1a6ab5", color:"#fff", fontWeight:800, fontSize:13, letterSpacing:1.5, padding:"13px 28px", borderRadius:8, textDecoration:"none", textTransform:"uppercase", transition:"all 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.background="#0d3c6e"; e.currentTarget.style.transform="translateY(-2px)"; }}
                onMouseLeave={e => { e.currentTarget.style.background="#1a6ab5"; e.currentTarget.style.transform="translateY(0)"; }}
              >Enquire Now <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg></a>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURED: PAINTING ── */}
      <section style={{ background:"#f0f7ff", padding:"48px 24px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:64, alignItems:"center" }}>
            <div>
              <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:12 }}>Painting & Finishing</div>
              <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(28px,4vw,46px)", fontWeight:900, color:"#0d3c6e", margin:"0 0 6px", textTransform:"uppercase", lineHeight:1.1 }}>Building & Villa<br/>Painting Services</h2>
              <p style={{ color:"#e8a800", fontWeight:700, fontSize:15, margin:"0 0 18px" }}>Bringing new life to your spaces with quality you can trust.</p>
              <p style={{ color:"#3a6080", fontSize:15, lineHeight:1.85, margin:"0 0 24px" }}>Premium interior and exterior painting for buildings and villas across UAE. From surface preparation to perfect final finish — expert team, quality paints, weather-resistant coatings tailored for the UAE climate.</p>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:28 }}>
                {[
                  { icon:<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>, label:"Durability", sub:"Long-lasting protection" },
                  { icon:<><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></>, label:"Aesthetic Appeal", sub:"Enhances property beauty" },
                  { icon:<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></>, label:"Value Boost", sub:"Increases property value" },
                  { icon:<><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></>, label:"Complete Solution", sub:"Surface prep to finish" },
                ].map(({ icon, label, sub }) => (
                  <div key={label} style={{ display:"flex", gap:12, alignItems:"flex-start", background:"#fff", borderRadius:10, padding:"12px 14px", boxShadow:"0 2px 8px rgba(26,106,181,0.07)" }}>
                    <div style={{ width:36, height:36, background:"#e8a800", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icon}</svg>
                    </div>
                    <div>
                      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:14, color:"#0d3c6e", textTransform:"uppercase" }}>{label}</div>
                      <div style={{ color:"#5a80a0", fontSize:12, lineHeight:1.4 }}>{sub}</div>
                    </div>
                  </div>
                ))}
              </div>
              <a href="/contact#form" style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#e8a800", color:"#0d3c6e", fontWeight:800, fontSize:13, letterSpacing:1.5, padding:"13px 28px", borderRadius:8, textDecoration:"none", textTransform:"uppercase", transition:"all 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.background="#d09800"; e.currentTarget.style.transform="translateY(-2px)"; }}
                onMouseLeave={e => { e.currentTarget.style.background="#e8a800"; e.currentTarget.style.transform="translateY(0)"; }}
              >Enquire Now <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg></a>
            </div>
            <div style={{ position:"relative", borderRadius:20, overflow:"hidden", boxShadow:"0 20px 60px rgba(13,60,110,0.15)" }}>
              <img src={villaImg} alt="Building & Villa Painting" style={{ width:"100%", display:"block", objectFit:"cover", transition:"transform 0.5s" }}
                onMouseEnter={e => e.currentTarget.style.transform="scale(1.03)"}
                onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}
              />
              <div style={{ position:"absolute", top:20, right:20, background:"#e8a800", borderRadius:10, padding:"8px 16px" }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, fontWeight:800, color:"#0d3c6e", textTransform:"uppercase", letterSpacing:1 }}>Featured Service</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES CARDS GRID */}
      <section style={{ background:"#f0f7ff", padding:"44px 24px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ marginBottom:48, display:"flex", justifyContent:"space-between", alignItems:"flex-end", flexWrap:"wrap", gap:16 }}>
            <div>
              <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:10 }}>What We Offer</div>
              <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(28px,4vw,48px)", fontWeight:900, color:"#0d3c6e", margin:0, textTransform:"uppercase" }}>Complete Service Range</h2>
            </div>
            <p style={{ color:"#5a80a0", fontSize:14, maxWidth:340, margin:0, lineHeight:1.7 }}>Click "View Description" on any service to read the full details.</p>
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:20 }}>
            {SERVICES.map((s, i) => (
              <div key={i}
                style={{ background:"#fff", borderRadius:16, padding:"28px 24px", boxShadow:"0 2px 12px rgba(26,106,181,0.07)", transition:"transform 0.25s, box-shadow 0.25s", display:"flex", flexDirection:"column" }}
                onMouseEnter={e => { e.currentTarget.style.transform="translateY(-4px)"; e.currentTarget.style.boxShadow="0 12px 32px rgba(26,106,181,0.13)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 2px 12px rgba(26,106,181,0.07)"; }}
              >
                {/* Icon + Title row */}
                <div style={{ display:"flex", alignItems:"flex-start", gap:14, marginBottom:12 }}>
                  <div style={{ width:52, height:52, background:s.bg, borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={s.color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      {getIconPath(s.tabler)}
                    </svg>
                  </div>
                  <h3 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:17, color:"#0d3c6e", margin:0, textTransform:"uppercase", lineHeight:1.25, paddingTop:4 }}>{s.title}</h3>
                </div>

                {/* Short desc */}
                <p style={{ color:"#5a80a0", fontSize:14, lineHeight:1.7, margin:"0 0 16px", flex:1 }}>{s.short}</p>

                {/* Expanded description */}
                {expanded === i && (
                  <div style={{ background:"#f0f7ff", borderRadius:10, padding:"14px 16px", marginBottom:14, animation:"expandDesc 0.3s ease forwards" }}>
                    <p style={{ color:"#3a6080", fontSize:13.5, lineHeight:1.8, margin:0 }}>{s.description}</p>
                  </div>
                )}

                {/* Toggle button */}
                <button
                  onClick={() => setExpanded(expanded === i ? null : i)}
                  style={{ display:"inline-flex", alignItems:"center", gap:7, color:"#1a6ab5", fontWeight:700, fontSize:13, textTransform:"uppercase", letterSpacing:0.5, border:"1.5px solid rgba(26,106,181,0.25)", borderRadius:8, padding:"9px 14px", background:"transparent", cursor:"pointer", transition:"all 0.2s", width:"fit-content" }}
                  onMouseEnter={e => { e.currentTarget.style.background="#1a6ab5"; e.currentTarget.style.color="#fff"; e.currentTarget.style.borderColor="#1a6ab5"; }}
                  onMouseLeave={e => { e.currentTarget.style.background="transparent"; e.currentTarget.style.color="#1a6ab5"; e.currentTarget.style.borderColor="rgba(26,106,181,0.25)"; }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    {expanded === i
                      ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                      : <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>
                    }
                  </svg>
                  {expanded === i ? "Hide Description" : "View Description"}
                </button>
                {expanded === i && (
                  <a href="/contact#form"
                    style={{ display:"inline-flex", alignItems:"center", gap:6, marginTop:12, color:"#1a6ab5", fontWeight:700, fontSize:13, textDecoration:"none", textTransform:"uppercase", letterSpacing:0.5, transition:"gap 0.2s" }}
                    onMouseEnter={e => e.currentTarget.style.gap="10px"}
                    onMouseLeave={e => e.currentTarget.style.gap="6px"}
                  >
                    Enquire Now
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SWIMMING POOL SECTION */}
      <section style={{ background:"#f0f7ff", padding:"48px 24px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <div style={{ color:"#1a6ab5", fontWeight:700, fontSize:12, letterSpacing:3, textTransform:"uppercase", marginBottom:12 }}>Additional Service</div>
            <h2 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"clamp(28px,4vw,48px)", fontWeight:900, color:"#0d3c6e", margin:"0 0 14px", textTransform:"uppercase" }}>Swimming Pool Works</h2>
            <div style={{ width:60, height:4, background:"#e8a800", borderRadius:2, margin:"0 auto" }}/>
          </div>

          <div className="pool-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:56, alignItems:"center" }}>
            {/* Slideshow */}
            <div style={{ position:"relative", height:420 }}>
              {POOL_IMAGES.map((src, i) => (
                <div key={i} style={{ position:"absolute", inset:0, borderRadius:20, overflow:"hidden", boxShadow:"0 20px 60px rgba(26,106,181,0.2)", border:"3px solid #fff", opacity:activePool===i?1:0, transition:"opacity 0.8s ease" }}>
                  <img src={src} alt={`pool-${i}`} style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
                  <div style={{ position:"absolute", bottom:0, left:0, right:0, height:"40%", background:"linear-gradient(transparent,rgba(13,60,110,0.6))" }}/>
                </div>
              ))}
              <div style={{ position:"absolute", bottom:16, left:"50%", transform:"translateX(-50%)", display:"flex", gap:8, zIndex:2 }}>
                {POOL_IMAGES.map((_, i) => (
                  <button key={i} onClick={() => setActivePool(i)}
                    style={{ width:activePool===i?24:8, height:8, borderRadius:4, background:activePool===i?"#e8a800":"rgba(255,255,255,0.5)", border:"none", cursor:"pointer", transition:"all 0.3s", padding:0 }}
                  />
                ))}
              </div>
              <div style={{ position:"absolute", top:20, right:20, background:"#e8a800", borderRadius:10, padding:"10px 16px", zIndex:2 }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:22, fontWeight:900, color:"#0d3c6e", lineHeight:1 }}>Weekly</div>
                <div style={{ fontSize:10, color:"#0d3c6e", textTransform:"uppercase", letterSpacing:1 }}>Contracts</div>
              </div>
            </div>

            {/* Content */}
            <div>
              <div style={{ display:"flex", gap:14, marginBottom:20 }}>
                <div style={{ width:52, height:52, background:"rgba(26,106,181,0.08)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a6ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12c.5-2 2.5-4 6-4s5.5 2 6 4 2.5 4 6 4"/><path d="M2 6c.5-2 2.5-4 6-4s5.5 2 6 4 2.5 4 6 4"/><path d="M2 18c.5-2 2.5-4 6-4s5.5 2 6 4 2.5 4 6 4"/></svg>
                </div>
                <div>
                  <h3 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:26, color:"#0d3c6e", margin:"0 0 4px", textTransform:"uppercase" }}>Meet Us Today</h3>
                  <p style={{ color:"#e8a800", fontWeight:700, fontSize:14, margin:0 }}>If you have any Swimming Pool Work</p>
                </div>
              </div>
              <div style={{ background:"rgba(232,168,0,0.1)", borderLeft:"3px solid #e8a800", borderRadius:"0 8px 8px 0", padding:"12px 18px", marginBottom:20 }}>
                <p style={{ color:"#0d3c6e", fontWeight:700, fontSize:15, margin:0 }}>We provide excellent pool maintenance services</p>
              </div>
              <p style={{ color:"#3a6080", fontSize:15, lineHeight:1.85, marginBottom:16 }}>Weekly, monthly, and annual pool maintenance contracts at the best prices in Dubai. Our expert team handles cleaning, chemical balancing, equipment servicing, and full refurbishments.</p>
              <p style={{ color:"#3a6080", fontSize:15, lineHeight:1.85, marginBottom:28 }}>From private villa pools to resort facilities, we ensure your pool is always safe, sparkling, and ready to use — year round.</p>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:28 }}>
                {["Pool Cleaning","Chemical Balancing","Equipment Repair","Full Refurbishment"].map(f => (
                  <div key={f} style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <div style={{ width:20, height:20, background:"#1a6ab5", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                    <span style={{ color:"#3a6080", fontSize:14 }}>{f}</span>
                  </div>
                ))}
              </div>
              <a href="/contact#form"
                style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#1a6ab5", color:"#fff", fontWeight:800, fontSize:13, letterSpacing:1.5, padding:"13px 28px", borderRadius:8, textDecoration:"none", textTransform:"uppercase", transition:"background 0.2s, transform 0.15s", boxShadow:"0 4px 20px rgba(26,106,181,0.25)" }}
                onMouseEnter={e => { e.currentTarget.style.background="#1558a0"; e.currentTarget.style.transform="translateY(-2px)"; }}
                onMouseLeave={e => { e.currentTarget.style.background="#1a6ab5"; e.currentTarget.style.transform="translateY(0)"; }}
              >
                Enquire Now
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function getIconPath(tabler) {
  const paths = {
    "ti-building": <><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18"/><path d="M3 9h6"/><path d="M3 15h6"/><path d="M12 8h3"/><path d="M12 12h3"/><path d="M12 16h3"/></>,
    "ti-tools": <><path d="M3 21l12-12"/><path d="M14.5 4.5l3 3-7 7-3-3z"/><path d="M19 10l-2-2 2.5-2.5a1.5 1.5 0 0 1 2 2L19 10z"/><path d="M5 19l-2 2"/></>,
    "ti-solar-panel": <><rect x="3" y="3" width="18" height="12" rx="1"/><path d="M3 9h18"/><path d="M9 3v12"/><path d="M15 3v12"/><path d="M12 15v6"/><path d="M9 21h6"/></>,
    "ti-bolt": <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    "ti-plant": <><path d="M7 15h10"/><path d="M12 9a3 3 0 0 0-3-3H5v3a3 3 0 0 0 6 0"/><path d="M12 9a3 3 0 0 1 3-3h4v3a3 3 0 0 1-7 0"/><path d="M12 21v-12"/></>,
    "ti-layout-grid": <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>,
    "ti-paint": <><path d="M5 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"/><path d="M9 9v3"/><path d="M15 9v3"/><path d="M8 12a4 4 0 0 0 8 0"/><path d="M12 16v5"/></>,
    "ti-armchair": <><path d="M5 11a2 2 0 0 0-2 2v4h18v-4a2 2 0 0 0-2-2"/><path d="M7 11V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v5"/><path d="M5 17v2"/><path d="M19 17v2"/></>,
    "ti-layers-intersect": <><path d="M8 4h11a1 1 0 0 1 1 1v11"/><rect x="4" y="8" width="12" height="12" rx="1"/></>,
    "ti-pencil": <><path d="M4 20h4l10.5-10.5a1.5 1.5 0 0 0-4-4L4 16v4"/><line x1="13.5" y1="6.5" x2="17.5" y2="10.5"/></>,
    "ti-fence": <><path d="M4 4v16"/><path d="M20 4v16"/><path d="M4 8h16"/><path d="M4 16h16"/><path d="M4 4l2-2 2 2"/><path d="M12 4l2-2 2 2"/><path d="M20 4l-2-2-2 2" style={{display:"none"}}/></>,
    "ti-layout-rows": <><rect x="3" y="3" width="18" height="7" rx="1"/><rect x="3" y="14" width="18" height="7" rx="1"/></>,
    "ti-square-rounded-plus": <><rect x="3" y="3" width="18" height="18" rx="4"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></>,
    "ti-droplet": <><path d="M12 2c0 0-7 7-7 12a7 7 0 0 0 14 0c0-5-7-12-7-12z"/></>,
    "ti-pipe": <><path d="M4 12h8"/><path d="M16 12h4"/><circle cx="14" cy="12" r="2"/><path d="M4 6v12"/></>,
    "ti-cpu": <><rect x="7" y="7" width="10" height="10" rx="1"/><path d="M9 3v4"/><path d="M15 3v4"/><path d="M9 17v4"/><path d="M15 17v4"/><path d="M3 9h4"/><path d="M3 15h4"/><path d="M17 9h4"/><path d="M17 15h4"/></>,
  };
  return paths[tabler] || <circle cx="12" cy="12" r="9"/>;
}